import { Fragment, useEffect, useState } from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import { CommonLoading } from 'react-loadingg';
import { ResetPasswordForm, ResetPhoneForm, ResetUserHeader } from '.';

const ResetUser = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [showEditResetPhoneNo, setShowEditResetPhoneNo] = useState(false);
    const [showEditResetPassword, setShowEditResetPassword] = useState(false);
    const [showResetPhoneForm, setResetPhoneForm] = useState(false);
    const [showResetPassForm, setResetPassForm] = useState(false);

    const handleResetPhoneForm = () => {
        setResetPhoneForm(!showResetPhoneForm);
        setResetPassForm(false);
    };
    const handleResetPassForm = () => {
        setResetPassForm(!showResetPassForm);
        setResetPhoneForm(false);
    };

    useEffect(() => {
        if (props.loginList) {
            const loginListFromParent = props.loginList;

            const permit = loginListFromParent.some(
                (item) =>
                    (item.permissionName.includes('Admin Role') &&
                        item.permissionType.includes('view')) ||
                    (item.permissionName.includes('Reset Phone Number') &&
                        item.permissionType.includes('view')) ||
                    (item.permissionName.includes('Reset Password') &&
                        item.permissionType.includes('view'))
            );

            if (!permit) {
                window.stop();
                alert('You have no permissions to access this page.');
                window.location = '/';
            } else {
                setIsLoading(false);
            }

            // const editResetPhoneNoPermit = loginListFromParent.some(
            //     (item) =>
            //         (item.permissionName.includes('Admin Role') &&
            //             item.permissionType.includes('edit')) ||
            //         (item.permissionName.includes('Reset Phone Number') &&
            //             item.permissionType.includes('edit'))
            // );

            // if (editResetPhoneNoPermit) {
            //     setShowEditResetPhoneNo(true);
            // }

            const editResetPasswordPermit = loginListFromParent.some(
                (item) =>
                    (item.permissionName.includes('Admin Role') &&
                        item.permissionType.includes('edit')) ||
                    (item.permissionName.includes('Reset Password') &&
                        item.permissionType.includes('edit'))
            );

            if (editResetPasswordPermit) {
                setShowEditResetPassword(true);
            }
        }
    }, [props.loginList]);

    return (
        <Fragment>
            {isLoading ? (
                <CommonLoading />
            ) : (
                <div className='main-hero-container'>
                    <div
                        className={`${
                            props.isActive ? 'container is-active' : 'container'
                        }`}
                    >
                        <ResetUserHeader />
                        <p style={{ marginLeft: '5px' }}>
                            NOT Applicable to Active Directory User
                        </p>
                        {/* <div
                            className={`${
                                showResetPhoneForm
                                    ? 'table-wrapper'
                                    : showResetPassForm
                                    ? 'table-wrapper'
                                    : ''
                            } `}
                        > */}
                        <div
                            className='table-wrapper'
                        >
                            {/* <ButtonGroup className='col-sm-4'>
                                {showEditResetPhoneNo && (
                                    <Button
                                        onClick={handleResetPhoneForm}
                                        variant={`${
                                            showResetPhoneForm
                                                ? 'primary'
                                                : 'outline-primary'
                                        }`}
                                        className='col-sm-3'
                                        style={{ margin: '5px 1px' }}
                                    >
                                        Reset User Phone Number
                                    </Button>
                                )}
                                {showEditResetPassword && (
                                    <Button
                                        onClick={handleResetPassForm}
                                        variant={`${
                                            showResetPassForm
                                                ? 'primary'
                                                : 'outline-primary'
                                        }`}
                                        className='col-sm-3'
                                        style={{ margin: '5px 0px' }}
                                    >
                                        Reset User Password
                                    </Button>
                                )}
                            </ButtonGroup> */}
                            {/* {showResetPhoneForm && <ResetPhoneForm />} */}
                            {/* {showResetPassForm && <ResetPasswordForm />} */}
                            <ResetPasswordForm />
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default ResetUser;
